import { LOGOUT_SUCCESS } from './redux-store/types/login';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore, compose } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { middleWareDispatch } from './redux-store/middleware';
import { rootReducer } from './redux-store/reducers';

export const history = createBrowserHistory();

const persistConfig = {
    key: 'mf-central',
    storage,
    whitelist: ['authReducer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer(connectRouter(history)));

// export const store = createStore(
//     persistedReducer,
//     applyMiddleware(thunk, middleWareDispatch, routerMiddleware(history)),
// );

// Compose enhancers adds support for the redux-devtools extension in the browser.
const isDevEnv = process.env.NODE_ENV == 'development'
const composeEnhancers = (isDevEnv && typeof window !== 'undefined' && (window as any)['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']) || compose
const store = createStore(
    persistedReducer,
    composeEnhancers(
        applyMiddleware(thunk, middleWareDispatch, routerMiddleware(history))
    )
);

history.listen(() => {
    document.getElementById('db-content-right')?.scrollTo(0, 0);
});
export const persistor = persistStore(store);
export default store;
